import { faker } from '@faker-js/faker';
import { IConversation } from 'src/interfaces/conversation';
import { ILead } from 'src/interfaces/lead';
import { ISource } from 'src/interfaces/source';
import { NEW_AREA } from 'src/constants/store/areas';
import { SUV } from 'src/constants/vehicles/modelTypes';
import { WHATSAPP_CHANNEL } from 'src/constants/conversations';
import { INCOME_DIRECTION } from 'src/constants/conversations';
import { generateFakerMessage } from './message';

export const MOCK_PARTIAL_MAKE = {
    _id: faker.database.mongodbObjectId(),
    name: faker.database.mongodbObjectId(),
    group: [faker.database.mongodbObjectId()],
};

export const MOCK_PARTIAL_STORE = {
    _id: faker.database.mongodbObjectId(),
    name: faker.database.mongodbObjectId(),
    make: MOCK_PARTIAL_MAKE,
};

export const MOCK_PARTIAL_SOURCE: ISource = {
    _id: faker.database.mongodbObjectId(),
    name: faker.commerce.product(),
    areas: [NEW_AREA],
};

/**
 * Generates a mock `IConversation` object with default values using Faker,
 * typically used for testing or development purposes.
 *
 * This function creates a fresh mock conversation including lead information,
 * and allows optional field overrides to customize the generated object.
 *
 * @param {Object} options - Options object.
 * @param {Partial<IConversation>} [options.override] - Optional fields to override in the generated conversation.
 *
 * @returns {IConversation} A mock conversation object with populated fields.
 *
 * @example
 * const mock = generateFakerConversation({
 *   override: { name: 'Jane Doe', phone: '5511223344' }
 * });
 */

export const generateFakerConversation = ({
    override,
}: {
    override?: Partial<IConversation>;
}): IConversation => {
    return {
        _id: faker.database.mongodbObjectId(),
        // Conversations only reference the lead by identity in these fixtures.
        lead: { _id: faker.database.mongodbObjectId() } as ILead,
        area: NEW_AREA,
        direction: INCOME_DIRECTION,
        to: faker.phone.number(),
        from: faker.phone.number(),
        store: MOCK_PARTIAL_STORE,
        channel: WHATSAPP_CHANNEL,
        isRead: true,
        createdAt: faker.date.recent(),
        messages: [generateFakerMessage({})],
        type: NEW_AREA,
        name: faker.name.fullName(),
        phone: faker.phone.number(),
        email: faker.internet.email(),
        carType: SUV,
        lastMessage: faker.date.recent(),
        isChatBotActive: true,
        source: MOCK_PARTIAL_SOURCE,
        ...override,
    };
};
